// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3etci","title":"FrontImage_title__Qx7qj"};